/* Our Farm Visits: tap a tile to play, tap again to pause. Nothing
   autoplays and nothing downloads until a visitor asks for it
   (preload="none"), which is what keeps a page of twelve clips light. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hl-visits__play');
    if (!btn) return;
    var wrap = btn.closest('[data-visit-clip]');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;

    if (video.paused) {
      /* one at a time: a grid of clips all running at once is noise */
      document.querySelectorAll('.hl-visits__video').forEach(function (v) {
        if (v !== video && !v.paused) {
          v.pause();
          v.closest('[data-visit-clip]').classList.remove('is-playing');
        }
      });
      video.play();
      wrap.classList.add('is-playing');
      wrap.removeAttribute('data-user-paused');
      btn.setAttribute('aria-label', 'Pause clip');
    } else {
      video.pause();
      wrap.classList.remove('is-playing');
      wrap.setAttribute('data-user-paused', '');
      btn.setAttribute('aria-label', 'Play clip');
    }
  });

  /* a clip scrolled out of view stops rather than playing to nobody;
     an autoplay clip starts itself the moment it scrolls in. Reduced
     motion turns autoplay off entirely - the play button still works. */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The hero loop runs slow (Marta, Aug 21). playbackRate is reset by some
     browsers when a source loads, so it is set again on loadedmetadata and
     after play() rather than once at parse time. */
  document.querySelectorAll('[data-visit-hero]').forEach(function (v) {
    var rate = parseFloat(v.getAttribute('data-speed'));
    if (!rate || rate <= 0 || rate === 1) return;
    var apply = function () { try { v.playbackRate = rate; } catch (e) {} };
    apply();
    v.addEventListener('loadedmetadata', apply);
    v.addEventListener('play', apply);
  });

  /* the hero loop is decorative; reduced motion holds it on its poster */
  if (reduceMotion) {
    document.querySelectorAll('[data-visit-hero]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target.querySelector('video');
        if (!v) return;
        if (entry.isIntersecting) {
          if (entry.target.hasAttribute('data-autoplay') && !reduceMotion && v.paused && !entry.target.hasAttribute('data-user-paused')) {
            var p = v.play();
            if (p) p.catch(function () {});
            entry.target.classList.add('is-playing');
          }
        } else if (!v.paused) {
          v.pause();
          entry.target.classList.remove('is-playing');
        }
      });
    }, { threshold: 0.35 });
    document.querySelectorAll('[data-visit-clip]').forEach(function (el) { io.observe(el); });
  }
})();
